import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { InputSkeleton } from '../../../input/input/subcomponents/skeleton';
import { LabelSkeleton } from '../../../label/subcomponents/skeleton';
const b = bemClassBuilder('v-field');
export const FieldSkeleton = props => {
    return (_jsxs("div", Object.assign({ className: b.block({ skeleton: true }, props.className) }, { children: [props.showLabel && _jsx(LabelSkeleton, {}), _jsx(InputSkeleton, {})] })));
};
